



















import BaseComponent from "@/components/BaseComponent.vue";
import { Component } from "vue-property-decorator";
import { SXCompany } from "@/gobl.bundle";

@Component
export default class WCompaniesSearch extends BaseComponent {
	searching: boolean = false;
	results: SXCompany[] = [];
	search: string = "";

	onSearch(search: string) {
		let x = this,
			always = () => (x.searching = false);
		x.searching = true;
		x.search = search;

		x.$services.companies.getAll(
			{
				filters: {
					[SXCompany.COL_NAME]: [["like", `%${search}%`]]
				}
			},
			function(response) {
				always();
				x.results = response.data.items;
			},
			function(response) {
				always();
				x.results = [];
			},
			false
		);
	}
}
